import React from "react";
import { useTheme } from "../theme/ThemeContext";

const LoadingSpinner = ({
  size = "medium",
  color = "primary",
  fullScreen = false,
  text = "",
}) => {
const { theme } = useTheme();
  const sizeClass = {
    small: "16px",
    medium: "24px",
    large: "32px"
  }[size];

  const colorClass = {
    primary: "#3498db",
    success: "#2ecc71",
    warning: "#f39c12",
    danger: "#e74c3c"
  }[color];

  const textColor = theme === "dark" ? "#ecf0f1" : "#666";
  const borderColor =
    theme === "dark"
      ? "rgba(255,255,255,0.1)"
      : "rgba(0,0,0,0.1)";

  if (fullScreen) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor:
            theme === "dark"
              ? "rgba(0,0,0,0.8)"
              : "rgba(255,255,255,0.9)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
          flexDirection: "column",
          gap: "20px"
        }}
      >
        <div
          style={{
            width: sizeClass,
            height: sizeClass,
            border: `3px solid ${borderColor}`,
            borderRadius: "50%",
            borderTop: `3px solid ${colorClass}`,
            animation: "spin 1s linear infinite"
          }}
        />

        {text && (
          <p style={{ color: textColor, margin: 0 }}>{text}</p>
        )}

        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px"
      }}
    >
      <div
        style={{
          width: sizeClass,
          height: sizeClass,
          border: `3px solid ${borderColor}`,
          borderRadius: "50%",
          borderTop: `3px solid ${colorClass}`,
          animation: "spin 1s linear infinite"
        }}
      />

      {text && (
        <p
          style={{
            color: textColor,
            margin: 0,
            fontSize: "12px"
          }}
        >
          {text}
        </p>
      )}

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;
